import React, { Component } from 'react';
import ContactForm from '../form/ContactForm';
import MailerLiteForm from '../form/MailerLiteForm';
import Alert from '../common/Alert';
import { FormattedMessage } from 'react-intl';

import api from '../../config/api';

class ContactPage extends Component{

	constructor() {
		super();
		this.state = {
			name: '',
			phone: '',
			email: '',
			message: '',
			alertMessage: '',
			alertType: '',
			alertRendered: false,
			contactButtonDisabled: false,
		};
	}

	setContactButtonState = (state) => {
		this.setState({
			contactButtonDisabled: state
		});
	};

	setContact = (name,value) => {
		this.setState({
			[name]:value
		});
	};

	sendContact = () => {

		const selectedLanguage = this.props.selectedLanguage;

		const options = {
			method: 'POST',
			body: JSON.stringify({
				name: this.state.name,
				email: this.state.email,
				phone: this.state.phone,
				message: this.state.message
			}),
			headers: new Headers({
				'Content-Type': 'application/json'
			})
		};

		fetch(api.contact(selectedLanguage.codeCountry), options)
			.then(res => res.json())
			.then(data => this.setState({
				name: data.status.includes('FAIL')? this.state.name : '',
				phone: data.status.includes('FAIL')? this.state.phone : '',
				email: data.status.includes('FAIL')? this.state.email : '',
				message: data.status.includes('FAIL')? this.state.message : '',
				alertMessage: data.text,
				alertType: data.status,
				alertRendered: true,
				contactButtonDisabled: false
			}))
			.catch(err => {
				console.log(err);
				this.setState({
					alertMessage: 'contact.fail.message',
					alertType: 'FAIL',
					alertRendered: true,
					contactButtonDisabled: false
				})
			});
	};

	render(){
		const page = this.props.page;
		const { alertType, alertMessage, alertRendered, name, phone, email, message, contactButtonDisabled} = this.state;
		return (
			<div className="container-flex">
				<div className="page__banner page__banner--contact">
					<h2>
						<FormattedMessage id={"page.title."+page.title.toLowerCase().replace(" ","-")} />
					</h2>
				</div>
				<div className="page page--column-sm">
					<div className={page.contentClass}>
						<h3>
							<FormattedMessage id="contact.title" />
						</h3>
						<Alert
							alertType={alertType}
						    alertMessage={<FormattedMessage id={alertMessage}/>}
						    rendered={alertRendered} />
						<ContactForm
							name={name}
							phone={phone}
							email={email}
							message={message}
							contactButtonDisabled={contactButtonDisabled}
						    setContact={this.setContact}
						    sendContact={this.sendContact}
							setContactButtonState={this.setContactButtonState}/>
					</div>
					<div className={page.sidebarClass}>
						<MailerLiteForm/>
					</div>
				</div>
			</div>
		);
	}
}

export default ContactPage;


// WEBPACK FOOTER //
// ./src/components/page/ContactPage.js